import { LoadingCapabilitiesAvailability } from "@freightsimple/generated-dashboard-openapi-client/models/LoadingCapabilitiesAvailability";

/**
 * Check if location has lift gate (which implies no dock)
 */
export function hasLiftGateAccessorial(accessorials: string[]): boolean {
  return accessorials.includes("LOGISTICS_LIFT_GATE_REQUIRED");
}

export function describeLoadingCapabilities(
  locationHasDock: LoadingCapabilitiesAvailability,
  locationHasForklift: LoadingCapabilitiesAvailability,
): string {
  const parts: string[] = [];

  if (locationHasDock === LoadingCapabilitiesAvailability.Yes) {
    parts.push("Has Dock");
  } else if (locationHasDock === LoadingCapabilitiesAvailability.No) {
    parts.push("No Dock");
  }

  if (locationHasForklift === LoadingCapabilitiesAvailability.Yes) {
    parts.push("Has Forklift");
  } else if (locationHasForklift === LoadingCapabilitiesAvailability.No) {
    parts.push("No Forklift");
  }

  if (parts.length === 0) {
    return "Not specified";
  }

  return parts.join(", ");
}
